import { useQuery } from "react-fetching-library";

export function useApiQuery(action, initFetch = true) {
  const queryResult = useQuery(action, initFetch);
  return queryResult;
}
